import React, { useEffect, useState } from 'react';

// Simple typewriter component with delete loop
export default function Typewriter({ strings = [], typingSpeed = 80, deletingSpeed = 40, pause = 1500, className = '' }) {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopIndex, setLoopIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (!strings || strings.length === 0) return;

    const currentString = strings[loopIndex % strings.length];
    let timeout;

    if (!isDeleting && charIndex <= currentString.length) {
      timeout = setTimeout(() => {
        setText(currentString.substring(0, charIndex));
        setCharIndex((i) => i + 1);
      }, typingSpeed);
    } else if (isDeleting && charIndex >= 0) {
      timeout = setTimeout(() => {
        setText(currentString.substring(0, charIndex));
        setCharIndex((i) => i - 1);
      }, deletingSpeed);
    }

    // When finished typing the full string, pause then start deleting
    if (!isDeleting && charIndex > currentString.length) {
      timeout = setTimeout(() => setIsDeleting(true), pause);
    }

    // When finished deleting, move to next string
    if (isDeleting && charIndex < 0) {
      setIsDeleting(false);
      setLoopIndex((idx) => idx + 1);
      setCharIndex(0);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, loopIndex, strings, typingSpeed, deletingSpeed, pause]);

  return (
    <span className={className} aria-live="polite">
      {text}
      <span className="inline-block ml-1" style={{ width: 8 }}>
        <span style={{ animation: 'tw-blink 1s step-end infinite' }}>|</span>
      </span>
      <style>{`@keyframes tw-blink{0%,49%{opacity:1}50%,100%{opacity:0}}`}</style>
    </span>
  );
}

